// extracted by mini-css-extract-plugin
export default {"selected":"_351b58ed33","un":"c33c2f2f19"};